/**
 * PoppinPay API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
* The PaymentSettings model module.
* @module model/PaymentSettings
* @version 1.0.0
*/
export default class PaymentSettings {
    /**
    * Constructs a new <code>PaymentSettings</code>.
    * @alias module:model/PaymentSettings
    * @class
    */

    constructor() {
        
        
        
    }

    /**
    * Constructs a <code>PaymentSettings</code> from a plain JavaScript object, optionally creating a new instance.
    * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
    * @param {Object} data The plain JavaScript object bearing properties of interest.
    * @param {module:model/PaymentSettings} obj Optional instance to populate.
    * @return {module:model/PaymentSettings} The populated <code>PaymentSettings</code> instance.
    */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new PaymentSettings();
                        
            
            if (data.hasOwnProperty('ApplicationId')) {
                obj['ApplicationId'] = ApiClient.convertToType(data['ApplicationId'], 'String');
            }
            if (data.hasOwnProperty('LocationId')) {
                obj['LocationId'] = ApiClient.convertToType(data['LocationId'], 'String');
            }
        }
        return obj;
    }

    /**
    * @member {String} ApplicationId
    */
    'ApplicationId' = undefined;
    /**
    * @member {String} LocationId
    */
    'LocationId' = undefined;




}
